import script from "./AudioFileComp.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioFileComp.vue?vue&type=script&setup=true&lang=js"

import "./AudioFileComp.vue?vue&type=style&index=0&id=8a946222&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a946222"]])

export default __exports__